export enum IssueStatusEnum {
  DRAFT = 'issue-draft',
  OPEN = 'issue-open',
  IN_PROGRESS = 'issue-in-progress',
  TO_BE_APPROVED = 'issue-to-be-approved',
  TO_BE_PUBLISHED = 'issue-to-be-published',
  PENDING_ACCEPTANCE = 'issue-pending-acceptance',
  CLOSED = 'issue-closed',
  DISCARDED = 'issue-discarded',
}

export type IssueStatusType =
  | IssueStatusEnum.DRAFT
  | IssueStatusEnum.OPEN
  | IssueStatusEnum.IN_PROGRESS
  | IssueStatusEnum.TO_BE_APPROVED
  | IssueStatusEnum.TO_BE_PUBLISHED
  | IssueStatusEnum.PENDING_ACCEPTANCE
  | IssueStatusEnum.CLOSED
  | IssueStatusEnum.DISCARDED;

export const IssueStatusNotActionable = [
  IssueStatusEnum.CLOSED,
  IssueStatusEnum.DISCARDED,
];

export const IssueStatusActionable = [
  IssueStatusEnum.DRAFT,
  IssueStatusEnum.OPEN,
  IssueStatusEnum.IN_PROGRESS,
  IssueStatusEnum.TO_BE_APPROVED,
  IssueStatusEnum.TO_BE_PUBLISHED,
  IssueStatusEnum.PENDING_ACCEPTANCE,
];
